import React from 'react';
import MusicCal from './MusicCal/MusicCal';

export default function Calendars() {
  return (
    <div id="calendars">
      <MusicCal />
    </div>
  );
}